import { motion } from "framer-motion";
import { Bell, CheckSquare, FileText, Mic } from "lucide-react";

const BARS = Array.from({ length: 28 }, (_, i) => 30 + ((i * 37) % 70));

const Waveform = () => (
  <div className="rounded-2xl border border-white/10 bg-card p-6">
    <div className="mb-5 flex items-center justify-between">
      <span className="flex items-center gap-2 font-mono text-xs text-muted-foreground">
        <span className="relative flex h-2.5 w-2.5">
          <span className="absolute inline-flex h-full w-full animate-pulse-ring rounded-full bg-pink" />
          <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-pink" />
        </span>
        REC · Biology 101 — Lecture 7
      </span>
      <span className="font-mono text-xs text-muted-foreground">48:12</span>
    </div>
    <div className="flex h-20 items-center gap-1">
      {BARS.map((h, i) => (
        <span key={i} className="w-full origin-center animate-wave rounded-full bg-cyan/80" style={{ height: `${h}%`, animationDelay: `${(i % 7) * 0.12}s` }} />
      ))}
    </div>
    <p className="mt-5 font-mono text-xs leading-relaxed text-muted-foreground">
      "…so for Friday, read chapter four on cell respiration, and remember the lab report is due next Tuesday…"
    </p>
  </div>
);

const ITEMS = [
  { icon: FileText, label: "Summary", text: "Cell respiration: glycolysis → Krebs cycle → electron transport.", tone: "text-cyan" },
  { icon: CheckSquare, label: "Task", text: "Read chapter 4 before Friday", tone: "text-cyan" },
  { icon: Bell, label: "Reminder", text: "Lab report due — Tuesday, 9:00", tone: "text-pink" },
];

export const HeroDemo = () => (
  <div data-testid="hero-demo" className="relative grid gap-4">
    <Waveform />
    <div className="flex justify-center">
      <span className="grid h-10 w-10 place-items-center rounded-full border border-white/10 bg-card"><Mic className="h-4 w-4 text-cyan" /></span>
    </div>
    <div className="grid gap-3">
      {ITEMS.map(({ icon: Icon, label, text, tone }, i) => (
        <motion.div
          key={label}
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.6 + i * 0.35, duration: 0.5 }}
          className="flex items-start gap-4 rounded-2xl border border-white/10 bg-card/80 p-4 backdrop-blur-xl"
        >
          <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${tone}`} />
          <div>
            <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">{label}</p>
            <p className="text-sm">{text}</p>
          </div>
        </motion.div>
      ))}
    </div>
    <p className="text-center font-mono text-[11px] text-muted-foreground">Example preview</p>
  </div>
);
